import { Schema as S } from "effect";

export const TagUsage = S.Struct({
	tag: S.String,
	nodeCount: S.Number,
	knotCount: S.Number,
	total: S.Number,
});
export type TagUsage = typeof TagUsage.Type;

export const TagList = S.Struct({ data: S.Array(TagUsage) });
export type TagList = typeof TagList.Type;
